import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import jwtDecode from 'jwt-decode';
import { message } from 'antd';
import { getItem, removeItem, setItem } from '../../utility/localStorageControl';
import { io } from 'socket.io-client';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr,
  getmsgBegin,
  getmsgSuccess,
  getmsgErr,
  signUpBegin,
  signUpSuccess,
  signUpErr,
} = actions;

const login = (values, callback) => {

  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.login('/auth/login', values);
      if (response.data !== null && response.data.Error === true) {
        message.error(response.data.message, 5);
        dispatch(loginErr(response.data.message));
      }
      else {
        const userInfo = await jwtDecode(response.data.access_token)
        if (response.data.Error === false && Object.keys(response.data).length !== 0 && 'access_token' in response.data
          && userInfo.role === "ADMIN" || userInfo.role === "EMPLOYEE"
          || userInfo.role === "INTERN" || userInfo.role === "TEAMLEAD") {
          setItem('access_token', response.data.access_token);
          setItem('logedIn', true);
          setItem('role', userInfo.role);
          setItem('username', userInfo.username);
          setItem('name', userInfo.name);
          setItem('userId', userInfo.id);
          setItem('image', userInfo.imagename);
          setItem('designation', userInfo.designation);
          dispatch(loginSuccess(true));
        }
        else {
          message.error("Invalid credentials")
          dispatch(loginErr("Invalid credentials"));
        }
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const signUp = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(signUpBegin());
      const response = await DataService.blob('POST', '/auth/signup', data);
      if (response !== null && response.data.Error === false) {
        await dispatch(signUpSuccess(response.data));
        message.success(response.data.message);
      } else if (response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(signUpSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(signUp(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(signUpErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};


const getMessage = () => {
  return async (dispatch) => {
    try {
      await dispatch(getmsgBegin());
      const response = await DataService.getMsg(`/message`);
      if (response.data.Error == false && response.data !== null) {
        await dispatch(getmsgSuccess(response.data.htmlcode));
      }
      else {
        await dispatch(getmsgSuccess(null));
      }
    } catch (err) {
      await dispatch(getmsgErr(err));
    }
  };
}

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      dispatch(logoutSuccess(false));
      const socket = io(process.env.REACT_APP_API_ENDPOINT);
      socket.emit('logout', parseInt(getItem('userId')))
      removeItem('logedIn');
      removeItem('access_token');
      removeItem('role')
      removeItem('username')
      removeItem('userId')
      removeItem('name')
      removeItem('image')
      removeItem('designation')
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, getMessage, signUp };